import React, { Component, createRef } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Moment from 'react-moment';
import { map } from "lodash"
import {
  Row,
  Col,
  Container,
  Table
} from "reactstrap"
import { API_URL } from "helpers/app_url";
import { getProjectWorksheetLeadDocDetail, getProjectWorksheetLeadPurDetail, getProjectWorksheetLeadUnitDetail, getProjectWorksheetUnitinfo } from "store/actions";
import RsLink from "components/buttons/rsLink";
class projectSrrPrint extends Component {
  constructor(props) {
    super(props)
    this.state = {
        
    }
    this.printRef = createRef();
  }

  componentDidMount() {
    const { match: { params }, onGetProjectWorksheetLeadPurDetail, onGetProjectWorksheetLeadUnitDetail, onGetProjectWorksheetLeadDocDetail, onGetProjectWorksheetUnitinfo } = this.props;
    onGetProjectWorksheetLeadPurDetail(params.id);
    onGetProjectWorksheetLeadUnitDetail(params.id);
    onGetProjectWorksheetLeadDocDetail(params.id);
    onGetProjectWorksheetUnitinfo(params.id)
  }
  handlePrint = () => {
    const printContent = this.printRef.current;
    const printWindow = window.open("", "", "width=800,height=600");
    
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print</title>
            <style>
              body { font-family: Arial, sans-serif; }
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #ddd; padding: 8px; }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
      printWindow.close();
    }
  };

  render() {
  
  const {worksheetPurData, worksheetUnitData, worksheetDocData} = this.props
    return (
      <React.Fragment>
     
       
        <div className="page-content project-page-content">

          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
            {/* <Row>
              <Col sm='2' className="pe-0" >
                <ProjectSidebar />
              </Col>
              <Col sm='10' className="ps-0">
                <Row className="project-header">
                  <Col sm="7">
                    <Breadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Worksheet")} />
                  </Col>
                  <Col sm="4">
                  
                  </Col>
                </Row>

                
           
            
              </Col>
            </Row> */}
            <Row>
                   <Col sm="3"></Col>
                   <Col sm="6">

                   <div ref={this.printRef}>
                   {map(worksheetPurData, (purData, purkey) => (
                        <>
                            <h4>Purchaser Detail</h4>
                          <h5>Purchaser {purkey + 1}</h5>
                          <div className="table-responsive">
                            <Table className="table table-sm m-0">

                              <tbody>
                                <tr>
                                  <th scope="row">Name</th>
                                  <td>{purData.firstName + " " + purData.lastName}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Address</th>
                                  <td>{purData.address}</td>
                                </tr>
                                <tr>
                                  <th scope="row">City</th>
                                  <td>{purData.city}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Province</th>
                                  <td>{purData.province}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Phone</th>
                                  <td>{purData.homePhone}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Cell</th>
                                  <td>{purData.cellPhone}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Email</th>
                                  <td>{purData.email}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Birth Date</th>
                                  <td>{purData.birthDate ? <Moment format="D MMM YY">{purData.birthDate}</Moment> : ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Drivers License</th>
                                  <td>{purData.driversLicense}</td>

                                </tr>
                                <tr>
                                  <th scope="row">Occupation</th>
                                  <td>{purData.occupation}</td>
                                </tr>

                              </tbody>
                            </Table>
                          </div>
                          <h4>Unit Choices Detail</h4>
                             <div className="table-responsive">
                                                  <Table className="table table-sm m-0">
                          
                                                    <tbody>
                                                     
                                                      {map(worksheetUnitData, (unitData, unitkey) => (
                                                        <>
                                                          <tr>
                                                            <th scope="row">Choice {unitkey + 1}</th>
                                                            <td>Model: {unitData.optionNumber} {" "} Type: {unitData.optionType}</td>
                          
                          
                                                          </tr>
                                                          <tr>
                                                            <td colSpan="2">Notes: {unitData.optionNotes}</td>
                                                          </tr>
                                                        </>
                                                      ))}
                          
                          
                                                    </tbody>
                                                  </Table>
                                                </div>
                          <p>{" "}</p>
                            <div className="table-responsive">
                           
                           
                                                   <h4>Document Detail</h4>
                                                   <Table className="table table-sm m-0">
                           
                                                     <tbody>
                                                       {map(worksheetDocData, (docData, dockey) => (
                                                         <tr>
                                                           <th scope="row">{dockey + 1}</th>
                                                           <td>{docData.documentTitle}</td>
                                                          
                                                         </tr>
                                                       ))}
                                                     </tbody>
                                                   </Table>
                                       </div>                               
                          <RsLink className="btn btn-add float-end" onClick={this.handlePrint}>Print</RsLink>
                        </>
                      ))}
                      </div>
                   </Col>
            </Row>
         
          </Container>
        </div>


      </React.Fragment>
    )
  }
}

projectSrrPrint.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  loading: PropTypes.object,
  onGetProjectWorksheetLeadPurDetail: PropTypes.func,
  onGetProjectWorksheetLeadUnitDetail: PropTypes.func,
  onGetProjectWorksheetLeadDocDetail: PropTypes.func,
  onGetProjectWorksheetUnitinfo: PropTypes.func,
  worksheetPurData:PropTypes.array,
  worksheetUnitData:PropTypes.array,
  worksheetDocData:PropTypes.array
  
}
const mapStateToProps = ({ Project }) => (
  {
    worksheetPurData: Project.worksheetPurData,
    worksheetUnitData: Project.worksheetUnitData,
    worksheetDocData: Project.worksheetDocData,
    unitdata: Project.unitdata,
  })
const mapDispatchToProps = dispatch => ({
 
 onGetProjectWorksheetLeadPurDetail: (id) => dispatch(getProjectWorksheetLeadPurDetail(id)),
  onGetProjectWorksheetLeadUnitDetail: (id) => dispatch(getProjectWorksheetLeadUnitDetail(id)),
  onGetProjectWorksheetLeadDocDetail: (id) => dispatch(getProjectWorksheetLeadDocDetail(id)),
  onGetProjectWorksheetUnitinfo: (id) => dispatch(getProjectWorksheetUnitinfo(id)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(projectSrrPrint)))
